import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      RELATED_ARTICLES: "Relaterte artikler",
      ARTICLE_PATH: (slug: string) => `/artikkel/${slug}`,
    },
    se: {
      RELATED_ARTICLES: "Relaterade artiklar",
      ARTICLE_PATH: (slug: string) => `/artikel/${slug}`,
    },
    dk: {
      RELATED_ARTICLES: "Relaterede artikler",
      ARTICLE_PATH: (slug: string) => `/artikel/${slug}`,
    },
  } as const
)[language];
